/**
 * The identity provider returns its response in the URL fragment — the very
 * place HashRouter claims the moment it mounts. Mounting rewrites the
 * fragment to "#/login", so the response is gone before MSAL, lazily
 * imported inside AuthProvider, ever runs: sign-in looped back to the login
 * screen with no error anywhere.
 *
 * So capture the fragment synchronously at startup, from main.tsx and before
 * React renders, and hand it to handleRedirectPromise() explicitly.
 */
const AUTH_RESPONSE = /[#&](code|error|id_token|access_token)=/;

let captured = "";

/** Called first thing in main.tsx, before ReactDOM renders. */
export function captureAuthRedirect(): void {
  if (AUTH_RESPONSE.test(window.location.hash)) captured = window.location.hash;
}

/** Consumed once by the OIDC module; empty on an ordinary page load. */
export function takeAuthRedirect(): string {
  const hash = captured;
  captured = "";
  return hash;
}
